import { render, staticRenderFns } from "./VeeObject.vue?vue&type=template&id=4cf3574a&"
import script from "./VeeObject.vue?vue&type=script&lang=js&"
export * from "./VeeObject.vue?vue&type=script&lang=js&"
import style0 from "./VeeObject.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports